export const SOCIAL_CONTENT_TEMPLATE = [
	{
		Type: 'miscellaneous',
		'Prompt Name': 'threeThingsResult',
		'Display Name': '🤔 Three Things Result',
		'Prompt Text':
			'You need [Number of things] things to [desired result]. \nThe first is [thing 1]. \nThe second is [thing 2]. \nAnd the third [thing 3]. \nIf you have those, then [desired outcome] is fully attainable.',
		'Formatted Prompt':
			'## You need [Number of things] things to [desired result]. \nThe first is [thing 1]. \nThe second is [thing 2]. \nAnd the third [thing 3]. \nIf you have those, then [desired outcome] is fully attainable.\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'amateursVsPros',
		'Display Name': '🏆 Amateurs vs Pros',
		'Prompt Text':
			'How amateurs [Topic] [Amateur Approach] [Amateur Approach] [Amateur Approach] How the pros do it [Pro Approach] [Pro Approach] [Pro Approach]',
		'Formatted Prompt':
			'## How amateurs [Topic] [Amateur Approach] [Amateur Approach] [Amateur Approach] How the pros do it [Pro Approach] [Pro Approach] [Pro Approach]\n\n',
	},
	{
		Type: 'longform',
		'Prompt Name': 'TSviralOpinions',
		'Display Name': '🔥 Viral Opinions',
		'Prompt Text':
			'[X] Controversial Opinions On [Topic] 99% Of The World Agrees With—But I Do Not\nI have been interested in [Topic] for a long time.\nAnd over the past [NumberOfYears], I have come across a lot of strong opinions about [Topic] that, at first, I agreed with...',
		'Formatted Prompt':
			'## [X] Controversial Opinions On [Topic] 99% Of The World Agrees With—But I Do Not\nI have been interested in [Topic] for a long time.\nAnd over the past [NumberOfYears], I have come across a lot of strong opinions about [Topic]...\n[Rest of the formatted content remains unchanged]\n\n',
	},
	{
		Type: 'eduContent',
		'Prompt Name': 'LessonsOnThing',
		'Display Name': '📚 Lessons on Topic',
		'Prompt Text':
			'Lessons on [Topic]\n[ShortContext]\nHere are [X] lessons I learned in [X Time]\n[Lesson1]\n[Lesson2]\n[Lesson3]\n[Lesson4]\n[Lesson5]\nHope this is helpful.',
		'Formatted Prompt':
			'## Lessons on [Topic]\n[ShortContext]\nHere are [X] lessons I learned in [X Time]\n[Lesson 1]\n[Lesson 2]\n[Lesson 3]\n[Lesson 4]\n[Lesson 5]\nHope this helps.\n\n',
	},
	{
		Type: 'eduContent',
		'Prompt Name': 'Lessons on thing I did today',
		'Display Name': '📝 Daily Lessons Today',
		'Prompt Text':
			"[DidThisThingToday]\n[ShortContext]\nHere are [X] lessons I learned in [X Time]\n[Lesson1]\n[Lesson2]\n[Lesson3]\n[Lesson4]\n[Lesson5]\nHope that's helpful.",
		'Formatted Prompt':
			"## [DidThisThingToday]\n[ShortContext]\nHere are [X] lessons I learned in [X Time]\n[Lesson1]\n[Lesson2]\n[Lesson3]\n[Lesson4]\n[Lesson5]\nHope that's helpful.\n\n",
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'topicSecrets',
		'Display Name': '🤫 Topic Secrets',
		'Prompt Text':
			'[Topic] secrets most people don’t know… [Secret #1] [Secret #2] [Secret #3] Shhh… don’t tell anyone.',
		'Formatted Prompt':
			'## [Topic] secrets most people don’t know… [Secret #1] [Secret #2] [Secret #3] Shhh… don’t tell anyone.\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'fourStepsDesiredOutcome',
		'Display Name': '👣 Four Steps Outcome',
		'Prompt Text':
			'The 4 steps to [Desired outcome]. \n- [Step1]\n- [Step2]\n- [Step3]\n- [Step4]\nNow learn how to follow these steps 👇. [Link]',
		'Formatted Prompt':
			'## The 4 steps to [Desired outcome]. \n- [Step1]\n- [Step2]\n- [Step3]\n- [Step4]\nNow learn how to follow these steps 👇. [Link]\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'badHabits',
		'Display Name': '🚫 Bad Habits List',
		'Prompt Text':
			'These things ruin you as a [Topic Person]: [Bad Habit #1] [Bad Habit #2] [Bad Habit #3] [Bad Habit #4] Avoid as many of these as possible.',
		'Formatted Prompt':
			'## These things ruin you as a [Topic Person]: [Bad Habit #1] [Bad Habit #2] [Bad Habit #3] [Bad Habit #4] Avoid as many of these as possible.\n\n',
	},
	{
		Type: 'longform',
		'Prompt Name': 'TS_reasonsPeopleFail',
		'Display Name': '❌ Reasons People Fail',
		'Prompt Text':
			'I have been doing X for a long time.\nOver the years, I have learned that most people who want to achieve X end up failing because [why]. They think [myth], and never realize Y is what’s actually holding them back...\n[Rest of the prompt remains unchanged]',
		'Formatted Prompt':
			'## I have been doing X for a long time.\nOver the years, I have learned that most people who want to achieve X end up failing because [why]. They think [myth], and never realize Y is what’s actually holding them back...\n[Rest of the formatted content remains unchanged]\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'simplerWay',
		'Display Name': '✨ Simpler Way Benefits',
		'Prompt Text':
			'[ContentTopic] is a simpler way to: - [Benefit 1, eg: Never run out of ideas] - [Benefit 2] - [Benefit 3]. Learn more 👇. [LINK]',
		'Formatted Prompt':
			'## [ContentTopic] is a simpler way to: - [Benefit 1, eg: Never run out of ideas] - [Benefit 2] - [Benefit 3]. Learn more 👇. [LINK]\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'bestExamples',
		'Display Name': '💡 Best Topic Examples',
		'Prompt Text':
			'The best examples of [Topic] I’ve ever seen: [Example #1] [Example #2] [Example #3] [Example #4] What others would you add?',
		'Formatted Prompt':
			'## The best examples of [Topic] I’ve ever seen: [Example #1] [Example #2] [Example #3] [Example #4] What others would you add?\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'threeThingsDesiredResult',
		'Display Name': '🧐 Three Things Outcome',
		'Prompt Text':
			'You need [Number of things] things to [desired result]. The first is [thing 1]. The second is [thing 2]. And the third [thing 3]. If you have those, then [desired outcome] is fully attainable.',
		'Formatted Prompt':
			'## You need [Number of things] things to [desired result]. The first is [thing 1]. The second is [thing 2]. And the third [thing 3]. If you have those, then [desired outcome] is fully attainable.\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'xQuestionsStruggles',
		'Display Name': '❓ Key Topic Questions',
		'Prompt Text':
			'[X] questions every [Topic] struggles to answer: [Question #1] [Question #2] [Question #3] [Question #4]',
		'Formatted Prompt':
			'## [X] questions every [Topic] struggles to answer: [Question #1] [Question #2] [Question #3] [Question #4]\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'stopShortTerm',
		'Display Name': '🙅 Stop Short-Term',
		'Prompt Text':
			'Stop trying to: [Short-Term Outcome] [Short-Term Outcome] [Short-Term Outcome]. Instead, just focus on [Action Step]. The rest will take care of itself.',
		'Formatted Prompt':
			'## Stop trying to: [Short-Term Outcome] [Short-Term Outcome] [Short-Term Outcome]. Instead, just focus on [Action Step]. The rest will take care of itself.\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'cruelReality',
		'Display Name': '💢 Cruel Reality',
		'Prompt Text':
			"The cruel reality of [obstacle] is that it's on purpose for many. They'll never break out of the self-limiting mindset and belief. Tell this person to learn [skill, idea], and they’ll tell you why it never works.",
		'Formatted Prompt':
			"## The cruel reality of [obstacle] is that it's on purpose for many. They'll never break out of the self-limiting mindset and belief. Tell this person to learn [skill, idea], and they’ll tell you why it never works.\n\n",
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'desiredOutcomeTimeframeObstacle',
		'Display Name': '⏳ Outcome Timeframe',
		'Prompt Text':
			"How I [Desired Outcome] in just [Timeframe] without [Obstacle]. If this sounds interesting, read this week's newsletter. [LINK]",
		'Formatted Prompt':
			"## How I [Desired Outcome] in just [Timeframe] without [Obstacle]. If this sounds interesting, read this week's newsletter. [LINK]\n\n",
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'fiveStepsSuccess',
		'Display Name': '🏅 Five Steps Success',
		'Prompt Text':
			'These are the steps for becoming a successful [Topic]: [Step #1] [Step #2] [Step #3] [Step #4] [Step #5] Follow these, and you’ll achieve [Goal].',
		'Formatted Prompt':
			'## These are the steps for becoming a successful [Topic]: [Step #1] [Step #2] [Step #3] [Step #4] [Step #5] Follow these, and you’ll achieve [Goal].\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'masterTopic',
		'Display Name': '🪄 Master Topic',
		'Prompt Text':
			'Want to master [Topic]? Use these [X] templates: [Template #1] [Template #2] [Template #3] [Template #4] [Template #5] They work every time.',
		'Formatted Prompt':
			'## Want to master [Topic]? Use these [X] templates: [Template #1] [Template #2] [Template #3] [Template #4] [Template #5] They work every time.\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'everTriedSamePlace',
		'Display Name': '🔁 Stuck Same Place',
		'Prompt Text':
			"If you've ever tried to [result they've tried to get], but ended up in the same place... This week’s [content] is your fix: [Link]",
		'Formatted Prompt':
			"## If you've ever tried to [result they've tried to get], but ended up in the same place... This week’s [content] is your fix: [Link]\n\n",
	},
	{
		Type: 'hype',
		'Prompt Name': 'numberOfKeysToDesire',
		'Display Name': '🔑 Keys to Success',
		'Prompt Text':
			'[Number] Keys to get [Desired outcome]: \n- [Key1] \n- [Key2] \n- [Key3]. \nI’ll/We’ll talk about this in the next [content piece eg. newsletter, youtube video, podcast], [Title].',
		'Formatted Prompt':
			'## [Number] Keys to get [Desired outcome]: \n- [Key1] \n- [Key2] \n- [Key3]. \nI’ll/We’ll talk about this in the next [content piece eg. newsletter, youtube video, podcast], [Title].\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': '90%ofX',
		'Display Name': '🔎 Ninety Percent',
		'Prompt Text':
			'90% of [Outcome] is really just:\n[Simple Habit #1].\n[Simple Habit #2].\n[Simple Habit #3].\nThe little stuff that makes all the difference.',
		'Formatted Prompt':
			'## 90% of [Outcome] is really just:\n[Simple Habit #1].\n[Simple Habit #2].\n[Simple Habit #3].\nThe little stuff that makes all the difference.\n\n',
	},
	{
		Type: 'longform',
		'Prompt Name': 'TS_lifelessons',
		'Display Name': '🌱 Life Lessons',
		'Prompt Text':
			'[X] Rules To Live A Life Filled With [Outcome1], [Outcome2], [Outcome3]\nOver the past [X] years, I have:\n[ShockingExperience]\n[OvercomeObstacle]\n[Accomplishment]\n[Rest of the prompt remains unchanged]',
		'Formatted Prompt':
			'## [X] Rules To Live A Life Filled With [Outcome1], [Outcome2], [Outcome3]\nOver the past [X] years, I have:\n[ShockingExperience]\n[OvercomeObstacle]\n[Accomplishment]\n[Rest of the formatted content remains unchanged]\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'youAreResponsibleFor',
		'Display Name': '🙋 You Are Responsible',
		'Prompt Text':
			'As a [career/identity], you are responsible for: [Responsibility 1] [Responsibility 2] [Responsibility 3]. Anyone can learn these things. Follow the footsteps of those who’ve been there before you.',
		'Formatted Prompt':
			'## As a [career/identity], you are responsible for: [Responsibility 1] [Responsibility 2] [Responsibility 3]. Anyone can learn these things. Follow the footsteps of those who’ve been there before you.\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'anotherTopic',
		'Display Name': '💡 Another Topic Tip',
		'Prompt Text':
			'Another good [Topic] tip: [Proven Tip]. Here’s why: [Reason]. Works every time.',
		'Formatted Prompt':
			'## Another good [Topic] tip: [Proven Tip]. Here’s why: [Reason]. Works every time.\n\n',
	},
	{
		Type: 'hype',
		'Prompt Name': 'titleContentFeature',
		'Display Name': '🚀 Title Published',
		'Prompt Text':
			'[Title] is published! \nGet: \n- [Feature1] \n- [Feature2] \n- [Feature3]. \nStart here. [Link]',
		'Formatted Prompt':
			'## [Title] is published! \nGet: \n- [Feature1] \n- [Feature2] \n- [Feature3]. \nStart here. [Link]\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'noSuccessThenWorked',
		'Display Name': '🔓 No Success Method',
		'Prompt Text':
			"I've/We’ve tried to [Result you can promise] without any kind of success. Until I/we found a way to make it work. Here's how to get faster results: [Link]",
		'Formatted Prompt':
			"## I've/We’ve tried to [Result you can promise] without any kind of success. Until I/we found a way to make it work. Here's how to get faster results: [Link]\n\n",
	},
	{
		Type: 'hype',
		'Prompt Name': 'finallyHere',
		'Display Name': '🎉 Finally Here',
		'Prompt Text':
			'[Title] is finally here! \nGet: \n- [Benefit1] \n- [Benefit2] \n- [Benefit3]. \nLet me/us know your biggest takeaway!',
		'Formatted Prompt':
			'## [Title] is finally here! \nGet: \n- [Benefit1] \n- [Benefit2] \n- [Benefit3]. \nLet me/us know your biggest takeaway!\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'topicGoals',
		'Display Name': '🎯 Topic Goals',
		'Prompt Text':
			'[Topic] goals you should strive for: [Goal #1] [Goal #2] [Goal #3] [Goal #4] Achieving these puts you in the top 1%.',
		'Formatted Prompt':
			'## [Topic] goals you should strive for: [Goal #1] [Goal #2] [Goal #3] [Goal #4] Achieving these puts you in the top 1%.\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'realNumbersCaseStudy',
		'Display Name': '📈 Real Numbers Case',
		'Prompt Text':
			'Case study: How I [Action] [Frequency] and achieved [Result].\nHere are the key lessons:\n1. [Lesson1]\n2. [Lesson2]\n3. [Lesson3]\nIf you do this, expect [Outcome].',
		'Formatted Prompt':
			'## Case study: How I [Action] [Frequency] and achieved [Result].\nHere are the key lessons:\n1. [Lesson1]\n2. [Lesson2]\n3. [Lesson3]\nIf you do this, expect [Outcome].\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'topicMythBuster',
		'Display Name': '🕵️ Topic Myth Buster',
		'Prompt Text':
			'People think [Myth1]... but the reality is [Reality1].\nPeople say [Myth2]... but the truth is [Reality2].\nWhich other myths about [Topic] have you heard?',
		'Formatted Prompt':
			'## People think [Myth1]... but the reality is [Reality1].\nPeople say [Myth2]... but the truth is [Reality2].\nWhich other myths about [Topic] have you heard?\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'oneQuestionInterview',
		'Display Name': '🎤 One Question Interview',
		'Prompt Text':
			'I asked [Expert/Influencer] one question about [Topic]:\n[Question]\nHere’s their surprising answer:\n[Answer]\nWhat’s your take?',
		'Formatted Prompt':
			'## I asked [Expert/Influencer] one question about [Topic]:\n[Question]\nHere’s their surprising answer:\n[Answer]\nWhat’s your take?\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'transformYourTopic',
		'Display Name': '🔥 Transform Topic',
		'Prompt Text':
			'Want to transform your [Topic]?\nUse this 3-step process:\n1. [Step1]\n2. [Step2]\n3. [Step3]\nIt’s more effective than you think.',
		'Formatted Prompt':
			'## Want to transform your [Topic]?\nUse this 3-step process:\n1. [Step1]\n2. [Step2]\n3. [Step3]\nIt’s more effective than you think.\n\n',
	},
	{
		Type: 'painPoints',
		'Prompt Name': 'beforeAfterStory',
		'Display Name': '🔥 Before After Story',
		'Prompt Text':
			'Before: [Frustration].\nAfter: [Solution].\nKey lesson learned: [Insight].\nIf you\'re stuck at "before," try this approach— it works.',
		'Formatted Prompt':
			'## Before: [Frustration].\nAfter: [Solution].\nKey lesson learned: [Insight].\nIf you\'re stuck at "before," try this approach— it works.\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'massiveValueCTA',
		'Display Name': '💎 Massive Value CTA',
		'Prompt Text':
			"Want to massively improve your [Topic]? Here's a quick hack:\n[Hack Description]\nIt helped me achieve [Result].\nTry it and see what happens.\n[CTA: Link or Instruction]",
		'Formatted Prompt':
			"## Want to massively improve your [Topic]? Here's a quick hack:\n[Hack Description]\nIt helped me achieve [Result].\nTry it and see what happens.\n[CTA: Link or Instruction]\n\n",
	},
	{
		Type: 'hype',
		'Prompt Name': 'unbelievableStats',
		'Display Name': '😲 Unbelievable Stats',
		'Prompt Text':
			"You won't believe these stats about [Topic]:\n[Stat #1]\n[Stat #2]\n[Stat #3]\nWhat do they tell us? [Insight].\nLet's talk about it.",
		'Formatted Prompt':
			"## You won't believe these stats about [Topic]:\n[Stat #1]\n[Stat #2]\n[Stat #3]\nWhat do they tell us? [Insight].\nLet's talk about it.\n\n",
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'badAdvice',
		'Display Name': '⚠️ Bad Advice Rant',
		'Prompt Text':
			'People keep saying "[Bad Advice]."\nBut in reality, here\'s why this advice hurts you:\n1. [Reason1]\n2. [Reason2]\n3. [Reason3]\nStop following bad advice.',
		'Formatted Prompt':
			'## People keep saying "[Bad Advice]."\nBut in reality, here\'s why this advice hurts you:\n1. [Reason1]\n2. [Reason2]\n3. [Reason3]\nStop following bad advice.\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'oneRuleToWin',
		'Display Name': '🏅 One Rule to Win',
		'Prompt Text':
			"The #1 rule to succeeding in [Topic] is simple:\n[Rule].\nBut here's what makes it hard:\n[Common Obstacle].\nFollow this rule, and watch things change.",
		'Formatted Prompt':
			"## The #1 rule to succeeding in [Topic] is simple:\n[Rule].\nBut here's what makes it hard:\n[Common Obstacle].\nFollow this rule, and watch things change.\n\n",
	},
	{
		Type: 'longform',
		'Prompt Name': 'expertRoundup',
		'Display Name': '🧩 Expert Roundup',
		'Prompt Text':
			'I asked [Number] experts about [Topic].\nHere are their top insights:\n[Expert1 Insight]\n[Expert2 Insight]\n[Expert3 Insight]\nWhich advice resonates with you the most?',
		'Formatted Prompt':
			'## I asked [Number] experts about [Topic].\nHere are their top insights:\n[Expert1 Insight]\n[Expert2 Insight]\n[Expert3 Insight]\nWhich advice resonates with you the most?\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'impossibleTillYouDo',
		'Display Name': '🚀 Impossible Until',
		'Prompt Text':
			'[Result] seems impossible until you:\n1. [Action1]\n2. [Action2]\n3. [Action3]\nOnce you do, it becomes inevitable.',
		'Formatted Prompt':
			'## [Result] seems impossible until you:\n1. [Action1]\n2. [Action2]\n3. [Action3]\nOnce you do, it becomes inevitable.\n\n',
	},
	{
		Type: 'eduContent',
		'Prompt Name': 'customerJourneyMap',
		'Display Name': '🗺 Customer Journey Map',
		'Prompt Text':
			'Mapping the journey for [Your Audience]:\nStage 1: [Awareness]\nStage 2: [Consideration]\nStage 3: [Decision]\nStage 4: [Success]\nHelp your audience at each stage.',
		'Formatted Prompt':
			'## Mapping the journey for [Your Audience]:\nStage 1: [Awareness]\nStage 2: [Consideration]\nStage 3: [Decision]\nStage 4: [Success]\nHelp your audience at each stage.\n\n',
	},
	{
		Type: 'painPoints',
		'Prompt Name': 'avoidThisTrap',
		'Display Name': '⛔ Avoid This Trap',
		'Prompt Text':
			'[Topic] trap you should avoid:\n[Trap Explanation].\nIf you find yourself doing this, stop and try [Alternative Action].\nSave yourself the headache.',
		'Formatted Prompt':
			'## [Topic] trap you should avoid:\n[Trap Explanation].\nIf you find yourself doing this, stop and try [Alternative Action].\nSave yourself the headache.\n\n',
	},
	{
		Type: 'hype',
		'Prompt Name': 'timelyTrend',
		'Display Name': '🔎 Timely Trend',
		'Prompt Text':
			'A new trend is emerging in [Topic]: [Trend Explanation].\nThis matters because [Reason].\nAre you prepared to adapt?',
		'Formatted Prompt':
			'## A new trend is emerging in [Topic]: [Trend Explanation].\nThis matters because [Reason].\nAre you prepared to adapt?\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'ifIStartedOver',
		'Display Name': '🔥 If I Started',
		'Prompt Text':
			"If I had to start over in [Topic] from scratch:\n1. I would do [Step1] first.\n2. Then [Step2].\n3. And focus on [Step3].\nIt's never too late to begin again.",
		'Formatted Prompt':
			"## If I had to start over in [Topic] from scratch:\n1. I would do [Step1] first.\n2. Then [Step2].\n3. And focus on [Step3].\nIt's never too late to begin again.\n\n",
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'counterintuitiveTruth',
		'Display Name': '🌀 Counterintuitive Truth',
		'Prompt Text':
			"The counterintuitive truth about [Topic] is this:\n[Unexpected Fact].\nIt goes against what most people believe.\nBut it's proven to be true time and time again.",
		'Formatted Prompt':
			"## The counterintuitive truth about [Topic] is this:\n[Unexpected Fact].\nIt goes against what most people believe.\nBut it's proven to be true time and time again.\n\n",
	},
	{
		Type: 'eduContent',
		'Prompt Name': 'usefulNumbers',
		'Display Name': '🔢 Useful Numbers',
		'Prompt Text':
			'Here are some key numbers about [Topic] you need to know:\n[Number1]: [Explanation1]\n[Number2]: [Explanation2]\n[Number3]: [Explanation3]\nKeep these in mind moving forward.',
		'Formatted Prompt':
			'## Here are some key numbers about [Topic] you need to know:\n[Number1]: [Explanation1]\n[Number2]: [Explanation2]\n[Number3]: [Explanation3]\nKeep these in mind moving forward.\n\n',
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'commonMistakesTopic',
		'Display Name': '🐞 Common Mistakes',
		'Prompt Text':
			'Common mistakes people make with [Topic]:\n1. [Mistake1]\n2. [Mistake2]\n3. [Mistake3]\nAvoid these, and your journey will be much smoother.',
		'Formatted Prompt':
			'## Common mistakes people make with [Topic]:\n1. [Mistake1]\n2. [Mistake2]\n3. [Mistake3]\nAvoid these, and your journey will be much smoother.\n\n',
	},
	{
		Type: 'longform',
		'Prompt Name': 'lightbulbMoment',
		'Display Name': '💡 Lightbulb Moment',
		'Prompt Text':
			'My big "aha" moment about [Topic] happened when [Situation].\nSuddenly, I realized:\n[Insight].\nAnd that changed the way I approach everything.',
		'Formatted Prompt':
			'## My big "aha" moment about [Topic] happened when [Situation].\nSuddenly, I realized:\n[Insight].\nAnd that changed the way I approach everything.\n\n',
	},
	{
		Type: 'painPoints',
		'Prompt Name': 'whyIStopped',
		'Display Name': '🔇 Why I Stopped',
		'Prompt Text':
			'I stopped doing [Old Habit] when I saw how it led to [Negative Outcome].\nNow, I do [New Habit] instead—because [Positive Outcome].\nSmall change, big difference.',
		'Formatted Prompt':
			'## I stopped doing [Old Habit] when I saw how it led to [Negative Outcome].\nNow, I do [New Habit] instead—because [Positive Outcome].\nSmall change, big difference.\n\n',
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'unexpectedGain',
		'Display Name': '🎁 Unexpected Gain',
		'Prompt Text':
			"I tried [New Tactic] hoping for [Expected Benefit], but I also got [Unexpected Benefit].\nHere's how:\n[Explanation].\nSometimes you discover bonuses along the way.",
		'Formatted Prompt':
			"## I tried [New Tactic] hoping for [Expected Benefit], but I also got [Unexpected Benefit].\nHere's how:\n[Explanation].\nSometimes you discover bonuses along the way.\n\n",
	},
	{
		Type: 'miscellaneous',
		'Prompt Name': 'fiveMinuteFix',
		'Display Name': '⏱ Five Minute Fix',
		'Prompt Text':
			"If you have [Common Problem], here's a 5-minute fix: [Fix Step]. Try it right now. Then do [Next Step]. This small tweak can yield big results.",
		'Formatted Prompt':
			"## If you have [Common Problem], here's a 5-minute fix: [Fix Step]. Try it right now. Then do [Next Step]. This small tweak can yield big results.\n\n",
	},
	{
		Type: 'painPoints',
		'Prompt Name': 'objectionKiller',
		'Display Name': '🛑 Objection Killer',
		'Prompt Text':
			"Think you can't [Action] because [Objection]? Actually, you can. Here's how to handle it: [Answer]. The real reason is [Root Cause]. Stop letting [Objection] hold you back.",
		'Formatted Prompt':
			"## Think you can't [Action] because [Objection]? Actually, you can. Here's how to handle it: [Answer]. The real reason is [Root Cause]. Stop letting [Objection] hold you back.\n\n",
	},
	{
		Type: 'longform',
		'Prompt Name': 'personalFailLesson',
		'Display Name': '🤕 Personal Fail Lesson',
		'Prompt Text':
			"I failed miserably at [Attempt]. Here's why I think it happened: [Reason]. What I learned from this failure: [Lesson]. Failure is never the end, it's the beginning of growth.",
		'Formatted Prompt':
			"## I failed miserably at [Attempt]. Here's why I think it happened: [Reason]. What I learned from this failure: [Lesson]. Failure is never the end, it's the beginning of growth.\n\n",
	},
	{
		Type: 'leanWriting',
		'Prompt Name': 'inversionApproach',
		'Display Name': '🔥 Inversion Approach',
		'Prompt Text':
			'Instead of asking "How to succeed at [Topic]?", ask "How to fail?" Then avoid those failure points: [Point1], [Point2], [Point3]. Sometimes success is just avoiding mistakes.',
		'Formatted Prompt':
			'## Instead of asking "How to succeed at [Topic]?", ask "How to fail?" Then avoid those failure points: [Point1], [Point2], [Point3]. Sometimes success is just avoiding mistakes.\n\n',
	},
];

export type SocialContentTemplate = (typeof SOCIAL_CONTENT_TEMPLATE)[number];
